export default {"src":"/_next/static/media/cSharpIcon.a0c84173.svg","height":32,"width":32};